import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button, Checkbox } from 'react-bootstrap';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import Status from '../Helper/Status';
import Combobox from '../Helper/Combobox';
import AbstractEntity from './AbstractEntity';

/**
* Class Contact
* Contact view component
**/
class Contact extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Contact";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="contactForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire du contact interne</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idContact" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idContact")} disabled="true" /></Col>
          </FormGroup>

          {/* Civilite OneToMany */}
          <FormGroup controlId="idCivilite">
            <Col componentClass={ControlLabel} sm={2}>Civilité</Col>
            <Col sm={6}><Combobox url={REST_API_URL + "civilites/"} optionValueKey="idCivilite" optionLabelKey="libelle" onChange={this.onCiviliteSelect.bind(this)}
              placeholder="Choisir une civilité" default={this.getObjectProperty("idCivilite")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>


          <FormGroup controlId="prenom">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Prénom</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("prenom")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="nom">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Nom</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("nom")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="interne"  style={{ display: 'none'}}>
            <Col smOffset={2} sm={2}><Checkbox name="interne" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("interne")} disabled={this.getReadOnly()}>Interne</Checkbox></Col>
          </FormGroup>

          <FormGroup controlId="telephone">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Téléphone</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("telephone")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="telephone2">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Téléphone complémentaire</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("telephone2")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="email1" validationState={this.getMailValidationState("email1", true)} >
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Mail</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("email1")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="email2" validationState={this.getMailValidationState("email2", true)} >
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Mail complémentaire</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("email2")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Commune OneToMany */}
          <FormGroup controlId="idCommune"  style={{ display: 'none' }}>
            <Col componentClass={ControlLabel} sm={2}>Commune</Col>
            <Col sm={6}><Combobox url={REST_API_URL + "communes/"} optionValueKey="gid" optionLabelKey="nom" onChange={this.onCommuneSelect.bind(this)} placeholder="Choisir une commune" default={this.getObjectProperty("idCommune")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaire">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}

  /**
  * onCommuneSelect
  * Modify the state idCommune property from idCommune Combobox change
  **/
  onCommuneSelect(commune) {
    let objState = this.state;
    objState.object["idCommune"] = commune.gid;
    this.setState(objState);
  }

  /**
  * onCiviliteSelect
  * Modify the state idCivilite property from idCivilite Combobox change
  **/
  onCiviliteSelect(civilite) {
    let objState = this.state;
    objState.object["idCivilite"] = civilite.idCivilite;
    this.setState(objState);
  }

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idContact";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    let contactObj = cloneObject(this.state.object);
    
    contactObj["interne"] = 'true';

    let state = this.state;

    // Validation des champs mails
    if(this.getMailValidationState("email1", true) === "error") {
      state.status = {
        type: 'danger',
        message: 'Le champ Mail n\'est pas valide.'
      };
      this.setState(state);
      return;
    }

    if(this.getMailValidationState("email2", true) === "error") {
      state.status = {
        type: 'danger',
        message: 'Le champ Mail complémentaire n\'est pas valide.'
      };
      this.setState(state);
      return;
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(contactObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        const newObj = JSON.parse(response.entity);

        this.setState({
          status: {
            type: 'success',
            message: 'Contact sauvegardé.'
          },
          object: newObj
        });

        if(this.props.onEdit) {
          this.props.onEdit.call(this, newObj);
        }
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Contact créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/contacts/" + newObj.idContact + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

}
export default Contact;



// WEBPACK FOOTER //
// ./src/views/Entity/Contact.js